module.exports = __webpack_public_path__ + "static/media/bytt-nn-5.a105f0bf.mp3";